import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00135772"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "plan_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "料金プラン変更", -1));
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", null, "料金プラン", -1));
const _hoisted_7 = { class: "title" };
const _hoisted_8 = { class: "bt_box" };
const _hoisted_9 = {
    key: 0,
    class: "lead text-margin"
};
const _hoisted_10 = {
    key: 1,
    class: "lead text-margin"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_12 = {
    id: "plan-modal",
    class: "modal type3 js-modal"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-bg" }, null, -1));
const _hoisted_14 = { class: "modal-content" };
const _hoisted_15 = { class: "close_bt" };
const _hoisted_16 = {
    key: 0,
    class: "pop"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "料金プラン変更", -1));
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "料金プランをお選びください", -1));
const _hoisted_19 = { class: "tab-wrap" };
const _hoisted_20 = ["value", "id"];
const _hoisted_21 = ["for"];
const _hoisted_22 = { class: "form-plan tab-content" };
const _hoisted_23 = { class: "plan-title" };
const _hoisted_24 = { class: "plan-main" };
const _hoisted_25 = { class: "plan-main-top" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "基本料金(月額)", -1));
const _hoisted_27 = { class: "plan-money" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "plan-type" }, "円(税込)", -1));
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "plan-main-top" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "基本料金(月額)")
], -1));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "plan-money" }, [
    /*#__PURE__*/ _createTextVNode(" 無料 "),
    /*#__PURE__*/ _createElementVNode("span", { class: "plan-type" }, "(相談は不可)")
], -1));
const _hoisted_31 = {
    key: 0,
    class: "plan-add"
};
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "追加相談", -1));
const _hoisted_33 = { class: "plan-article" };
const _hoisted_34 = { style: { "font-size": "1.8rem", "padding-bottom": "20px" } };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { style: { "padding-right": "30px" } }, "変更開始日", -1));
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "※料金プランの変更は、翌月１日分から変更適用となります。", -1));
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "plan-alart" }, " ※この変更適用後に、キャンセルすることはできません。 ", -1));
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "plan-article" }, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode(" ※日割りできないので、初月の基本料金は、申込日に応じて次の対応とさせて頂きます。"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" 申込日が1～15日：基本料金を全額支払い（質問チケットは基本と同数）"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" 申込日が16～末日：基本料金を半額支払い（質問チケットは基本の半数） ")
    ])
], -1));
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "plan-alart" }, "※このお申込後に、キャンセルすることはできません。", -1));
const _hoisted_40 = { class: "bt_box clear" };
const _hoisted_41 = { class: "modalBtn-area b2" };
const _hoisted_42 = ["disabled"];
const _hoisted_43 = {
    key: 1,
    class: "pop"
};
const _hoisted_44 = { class: "spinner-container" };
const _hoisted_45 = { class: "spinner" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "message-box" }, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createElementVNode("strong", null, "現在決済処理中です")
    ]),
    /*#__PURE__*/ _createElementVNode("p", null, "ボタンを押したり移動したりせず、このまましばらくお待ちください。処理が完了したら自動的に画面が変わります。")
], -1));
import { inject, ref, reactive, watch, computed, onBeforeMount, onMounted, nextTick } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';
import moment from 'moment';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import { PlanCategory } from '@util/Consts';
import ImageFrame from '@component/ImageFrame.vue';
import { isObjEmpty } from '@util/Common';
import swal from 'sweetalert';
import { loadStripe } from '@stripe/stripe-js';
export default /*#__PURE__*/ _defineComponent({
    __name: 'plan_entry',
    props: {
        common: null,
        errors: null,
        plan: null,
        card_id: null,
        pre_order: null,
        plan_name: null,
        pre_order_plan_name: null,
        is_card_expire: { type: Boolean },
        create_question_available: { type: Boolean },
        payment_intent_client_secret: null
    },
    setup(__props) {
        const props = __props;
        let stripe = null;
        const validate = reactive({ shot: false });
        const form = reactive({
            plan_id: props.plan.plan_id,
        });
        const close = ref();
        const options = ref([]);
        const nextDate = ref('');
        const MSG_NONE = 0;
        const MSG_CHANGE_PLAN = 1;
        const MSG_CHANGE_PAID_PLAN = 2;
        const msgType = ref(MSG_NONE);
        const showLoading = ref(false);
        const showNowPlan = computed(() => {
            var _a, _b;
            if (((_a = props.plan) === null || _a === void 0 ? void 0 : _a.plan_id) === PlanCategory.GUEST_PLAN) {
                return 'ゲスト';
            }
            return (_b = props.plan_name) !== null && _b !== void 0 ? _b : '';
        });
        const showNextPlan = computed(() => {
            var _a, _b;
            if ((props === null || props === void 0 ? void 0 : props.pre_order) && ((_a = props === null || props === void 0 ? void 0 : props.pre_order) === null || _a === void 0 ? void 0 : _a.plan_id) !== ((_b = props.plan) === null || _b === void 0 ? void 0 : _b.plan_id)) {
                return (props === null || props === void 0 ? void 0 : props.pre_order_plan_name) ? `${nextDate.value}〜　${props.pre_order_plan_name}に変更予定` : '';
            }
            return '';
        });
        watch(() => form.plan_id, value => {
            var _a, _b;
            const plan_id = (_b = (_a = props.plan) === null || _a === void 0 ? void 0 : _a.plan_id) !== null && _b !== void 0 ? _b : PlanCategory.FREE_PLAN;
            if (value == PlanCategory.FREE_PLAN) {
                msgType.value = MSG_NONE;
            }
            else {
                // プランが変更されていた場合、元々がフリーか有料でメッセージ切り替え
                msgType.value =
                    plan_id === PlanCategory.FREE_PLAN || plan_id === PlanCategory.GUEST_PLAN
                        ? MSG_CHANGE_PAID_PLAN
                        : MSG_CHANGE_PLAN;
            }
        });
        // disable button to change for  preorder same plan
        const disabled = computed(() => {
            var _a;
            return form.plan_id == ((_a = props.pre_order) === null || _a === void 0 ? void 0 : _a.plan_id);
        });
        const onClickCancel = () => {
            close.value.click();
            setTimeout(() => {
                var _a, _b;
                let form_plan_id = props.plan.plan_id;
                if (props.plan.plan_id === PlanCategory.GUEST_PLAN) {
                    form_plan_id = PlanCategory.FREE_PLAN;
                }
                form.plan_id = (_b = (_a = props.pre_order) === null || _a === void 0 ? void 0 : _a.plan_id) !== null && _b !== void 0 ? _b : form_plan_id;
                validate.shot = false;
            }, 1000);
        };
        const onClickOk = () => {
            const isFreeUser = ((props.plan.plan_id == PlanCategory.GUEST_PLAN || props.plan.plan_id == PlanCategory.FREE_PLAN) && (form.plan_id != PlanCategory.GUEST_PLAN || form.plan_id != PlanCategory.FREE_PLAN));
            if ((props === null || props === void 0 ? void 0 : props.card_id) && isFreeUser) {
                if (form.plan_id == PlanCategory.FREE_PLAN)
                    return;
                const message = '有料プランを選択すると即時課金されますがよろしいですか？';
                if (!window.confirm(message))
                    return;
            }
            showLoading.value = true;
            Inertia.post(route('plan.update'), { plan_id: form.plan_id }, {
                onSuccess: () => {
                    setTimeout(() => {
                        close.value.click();
                        showLoading.value = false;
                    }, 10000);
                },
                onError: () => {
                    validate.shot = true;
                    showLoading.value = false;
                    swal({
                        title: "確認",
                        text: "クレジットカード決済できませんでした。必要により別カードの登録をご検討ください。",
                        icon: "warning",
                        buttons: {
                            ok: {
                                text: "OK",
                                className: "timeout-ok-btn",
                            },
                        },
                    }).then((value) => {
                        if (value) {
                            //validate.shot = true;
                            close.value.click();
                        }
                    });
                },
            });
        };
        const onClickMainPlanPay = () => {
            if (props === null || props === void 0 ? void 0 : props.card_id) {
                const message = '即時課金されますがよろしいでしょうか？';
                if (!window.confirm(message))
                    return;
            }
            Inertia.post(route('plan.main_plan_pay'), { plan_id: form.plan_id }, {
                onSuccess: () => {
                    // close.value.click();
                },
                onError: () => {
                    // validate.shot = true;
                },
            });
        };
        const onClickGotoPaymentPage = () => {
            Inertia.get(route('payment.show'));
        };
        const onClickPlanModel = () => {
            if (form.plan_id !== PlanCategory.FREE_PLAN && form.plan_id !== PlanCategory.GUEST_PLAN) {
                msgType.value = MSG_CHANGE_PLAN;
            }
        };
        onMounted(() => {
            var _a, _b;
            const publishableKey = inject('stripePublicKey');
            const secretKey = inject('stripeSecretKey');
            const stripePromise = loadStripe(publishableKey);
            stripePromise.then(stripe => {
                if (props.payment_intent_client_secret) {
                    const payment_intent_client_secret = props.payment_intent_client_secret;
                    stripe.retrievePaymentIntent(payment_intent_client_secret)
                        .then(function (result) {
                        console.log(result);
                        if (!result.error) {
                            if (result.paymentIntent.status === 'requires_payment_method') {
                                // Authentication failed, prompt the customer to enter another payment method
                                swal({
                                    title: "確認",
                                    text: "クレジットカードの認証に失敗したので、有料プランを登録できません。 必要により支払方法登録画面で別カードの登録をご検討ください。",
                                    icon: "warning",
                                    buttons: {
                                        ok: {
                                            text: "OK",
                                            className: "timeout-ok-btn",
                                        },
                                    },
                                });
                            }
                        }
                    });
                }
            });
            validate.shot = isObjEmpty(props.errors);
            form.plan_id = (_b = (_a = props.pre_order) === null || _a === void 0 ? void 0 : _a.plan_id) !== null && _b !== void 0 ? _b : props.plan.plan_id;
            if (form.plan_id === PlanCategory.GUEST_PLAN)
                form.plan_id = PlanCategory.FREE_PLAN;
            nextDate.value = moment(new Date()).add(1, 'months').startOf('month').format('YYYY年MM月DD日');
            nextTick(() => {
                var key = require.resolve('@jquery/datepicker-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/datepicker-jquery');
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onBeforeMount(() => {
            axios.get(route('plans')).then(response => {
                var _a;
                options.value = (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : [];
            });
        });
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("form", null, [
                                    _createElementVNode("dl", null, [
                                        _hoisted_6,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(showNowPlan)), 1),
                                            _createTextVNode(" " + _toDisplayString(_unref(showNextPlan)), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        (!(props === null || props === void 0 ? void 0 : props.card_id) || props.is_card_expire)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (!(props === null || props === void 0 ? void 0 : props.card_id))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, " 有料プランへの変更は支払方法を先に登録してください。 "))
                                                    : _createCommentVNode("", true),
                                                (props === null || props === void 0 ? void 0 : props.is_card_expire)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                                        _createTextVNode(" クレジットカードの有効期限が切れています。"),
                                                        _hoisted_11,
                                                        (((_a = props === null || props === void 0 ? void 0 : props.plan) === null || _a === void 0 ? void 0 : _a.plan_id) !== 1)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode("もう一度支払い方法登録をお願い致します。")
                                                            ], 64))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createVNode(_unref(Link), {
                                                    href: _ctx.route('payment.show', { plan: true }),
                                                    class: "bt_change modal_win"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" 支払方法登録 ")
                                                    ]),
                                                    _: 1
                                                }, 8, ["href"])
                                            ], 64))
                                            : (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                class: "bt_change modal_win",
                                                "data-target": "plan-modal",
                                                onClick: onClickPlanModel
                                            }, "変更"))
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("form", null, [
                        _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(ImageFrame, {
                                        src: "images/common/i_bt_close.svg",
                                        class: "bt_modal_close",
                                        onClick: onClickCancel
                                    })
                                ]),
                                (!showLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _hoisted_17,
                                        _hoisted_18,
                                        _createElementVNode("div", _hoisted_19, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
                                                var _a, _b, _c, _d, _e;
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.plan_id) = $event)),
                                                        value: option.id,
                                                        id: `TAB-${index}`,
                                                        type: "radio",
                                                        name: "TAB",
                                                        class: "tab-switch"
                                                    }, null, 8, _hoisted_20), [
                                                        [_vModelRadio, form.plan_id]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "tab-label",
                                                        for: `TAB-${index}`
                                                    }, _toDisplayString(option.name), 9, _hoisted_21),
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _createElementVNode("p", _hoisted_23, _toDisplayString(`${option.name}プラン`), 1),
                                                        _createElementVNode("div", _hoisted_24, [
                                                            (option.id !== _unref(PlanCategory).FREE_PLAN)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createElementVNode("div", _hoisted_25, [
                                                                        _hoisted_26,
                                                                        _createElementVNode("p", null, "(相談" + _toDisplayString((_a = option === null || option === void 0 ? void 0 : option.monthly_question_count) !== null && _a !== void 0 ? _a : 0) + "件以内/月)", 1)
                                                                    ]),
                                                                    _createElementVNode("p", _hoisted_27, [
                                                                        _createTextVNode(_toDisplayString((_c = ((_b = option === null || option === void 0 ? void 0 : option.monthly_amount) !== null && _b !== void 0 ? _b : 0)) === null || _c === void 0 ? void 0 : _c.toLocaleString()), 1),
                                                                        _hoisted_28
                                                                    ])
                                                                ], 64))
                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _hoisted_29,
                                                                    _hoisted_30
                                                                ], 64))
                                                        ]),
                                                        (option.is_allowed_additional_question)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                                _hoisted_32,
                                                                _createElementVNode("p", null, _toDisplayString((_e = ((_d = option.additional_question_amount) !== null && _d !== void 0 ? _d : 0)) === null || _e === void 0 ? void 0 : _e.toLocaleString()) + "円 / 件(税込) ", 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (msgType.value === MSG_CHANGE_PLAN)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createElementVNode("div", _hoisted_33, [
                                                                    _createElementVNode("div", _hoisted_34, [
                                                                        _hoisted_35,
                                                                        _createElementVNode("span", null, _toDisplayString(nextDate.value) + "〜", 1)
                                                                    ]),
                                                                    _hoisted_36
                                                                ]),
                                                                _hoisted_37
                                                            ], 64))
                                                            : (msgType.value === MSG_CHANGE_PAID_PLAN)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                    _hoisted_38,
                                                                    _hoisted_39
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                                    ])
                                                ], 64));
                                            }), 256))
                                        ]),
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("ul", _hoisted_41, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_modal_close bt_clear",
                                                        onClick: onClickCancel
                                                    }, "キャンセル")
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "bt_ok",
                                                        onClick: onClickOk,
                                                        disabled: _unref(disabled)
                                                    }, " OK ", 8, _hoisted_42)
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        _createElementVNode("div", _hoisted_44, [
                                            _createElementVNode("div", _hoisted_45, [
                                                _createVNode(ImageFrame, { src: "images/index/loading.gif" })
                                            ]),
                                            _hoisted_46
                                        ])
                                    ])),
                                _createElementVNode("p", {
                                    class: "bt_modal_close",
                                    ref_key: "close",
                                    ref: close,
                                    style: { "display": "none" }
                                }, null, 512)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
